import { FieldNormalizer } from '../types';

export default class FakeNormalizer implements FieldNormalizer {
  normalize(value: any): any {
    return value;
  }

  reverseNormalize(value: any) {
    return value;
  }
}
